import greycat from '@greycat/core-wasm';
import Keys from './__gen/keys';
import * as WebSocket from 'isomorphic-ws';
export { default as Keys } from './__gen/keys';
export class GObject {
    constructor(ptr) {
        this.native_ptr = ptr;
    }
    unmark() {
        greycat._gobject__un_mark(this.native_ptr);
    }
    type() {
        const type_ptr = greycat._object__type(this.native_ptr);
        let type_obj = GreyCat.elements[type_ptr];
        if (type_obj == null) {
            type_obj = new Type(type_ptr);
            GreyCat.elements[type_ptr] = type_obj;
        }
        return type_obj;
    }
    graph() {
        const graph_ptr = greycat._object__graph(this.native_ptr);
        return GreyCat.elements[graph_ptr];
    }
    toString() {
        const graph_ptr = greycat._object__graph(this.native_ptr);
        const buffer = greycat._ggraph__create_string(graph_ptr);
        greycat._object__json(this.native_ptr, buffer);
        greycat._gstring__close(buffer);
        const buffer_raw = greycat._gstring__get(buffer);
        const result = greycat.Pointer_stringify(buffer_raw);
        greycat._gobject__un_mark(buffer);
        return result;
    }
    toObject() {
        return JSON.parse(this.toString());
    }
    ptr() {
        return this.native_ptr;
    }
}
export class Type extends GObject {
    constructor(ptr) {
        super(ptr);
        this.clazz = null;
    }
    name() {
        const name_ptr = greycat._type__name(this.native_ptr);
        if (name_ptr === 0) {
            return '' + this.key();
        }
        const buffer_raw = greycat._gstring__get(name_ptr);
        return greycat.Pointer_stringify(buffer_raw);
    }
    setName(name) {
        greycat._type__set_name(this.native_ptr, GreyCat.prop_id_to_key(name, this));
        return this;
    }
    key() {
        return greycat._type__key(this.native_ptr);
    }
    setClass(clazz) {
        this.clazz = clazz;
        return this;
    }
    isPrimitive() {
        return greycat._type__is_primitive(this.native_ptr) === 1;
    }
    isNode() {
        return greycat._type__is_node(this.native_ptr) === 1;
    }
    isOpen() {
        return greycat._type__is_open(this.native_ptr) === 1;
    }
    setIsOpen() {
        greycat._type__set_is_open(this.native_ptr);
        return this;
    }
    declareAttribute(key, type) {
        if (typeof type === 'number') {
            greycat._gtype__declare_attribute(this.native_ptr, GreyCat.prop_id_to_key(key), type);
        }
        else {
            greycat._gtype__declare_attribute(this.native_ptr, GreyCat.prop_id_to_key(key), GreyCat.hash(type));
        }
        return this;
    }
    declareStatic(key, value) {
        if (typeof value === 'string') {
            const js_str = value;
            const ptr_str = greycat._js_malloc(js_str.length + 1);
            greycat.writeAsciiToMemory(js_str, ptr_str, false);
            greycat._type__declare_static_raw_string(this.native_ptr, GreyCat.prop_id_to_key(key, this), ptr_str);
            greycat._js_free(ptr_str);
        }
        else if (typeof value === 'number') {
            if (value % 1 !== 0) {
                greycat._type__declare_static_double(this.native_ptr, GreyCat.prop_id_to_key(key, this), value);
            }
            else if (value > Number.MIN_SAFE_INTEGER - 1 && value < Number.MAX_SAFE_INTEGER + 1) {
                greycat._type__declare_static_int(this.native_ptr, GreyCat.prop_id_to_key(key, this), value);
            }
            else {
                greycat._type__declare_static_long(this.native_ptr, GreyCat.prop_id_to_key(key, this), value);
            }
        }
        else if (value instanceof GObject) {
            greycat._gtype__declare_constant(this.native_ptr, GreyCat.prop_id_to_key(key, this), value.ptr(), Keys.g_function);
        }
        return this;
    }
    declareFunction(key, value) {
        if (value instanceof GFunction) {
            greycat._gtype__declare_constant(this.native_ptr, GreyCat.prop_id_to_key(key, this), value.ptr(), Keys.g_function);
        }
        else {
            const graph_ptr = greycat._type__graph(this.native_ptr);
            const anonymous_func_ptr = greycat._function__create(graph_ptr, this.native_ptr);
            GreyCat.elements[anonymous_func_ptr] = value;
            greycat._gtype__declare_constant(this.native_ptr, GreyCat.prop_id_to_key(key, this), anonymous_func_ptr, Keys.g_function);
            greycat._gobject__un_mark(anonymous_func_ptr, Keys.g_function);
        }
        return this;
    }
    seal() {
        greycat._type__seal(this.native_ptr);
    }
    box(object_ptr) {
        if (object_ptr === 0) {
            return null;
        }
        if (this.isNode()) {
            if (this.clazz == null) {
                return new OpenNode(object_ptr);
            }
            else {
                return new this.clazz(object_ptr);
            }
        }
        else {
            if (this.clazz != null) {
                return new this.clazz(object_ptr);
            }
            switch (this.key()) {
                case Keys.g_null:
                    return null;
                case Keys.g_bool:
                    return greycat._js_read_bool(object_ptr) === 1;
                case Keys.g_long:
                    return greycat._js_read_long(object_ptr);
                case Keys.g_ulong:
                    return greycat._js_read_ulong(object_ptr);
                case Keys.g_double:
                    return greycat._js_read_double(object_ptr);
                case Keys.g_meta_key:
                case Keys.g_var_key:
                case Keys.g_var_key_new:
                case Keys.g_function_key:
                case Keys.g_int:
                    return greycat._js_read_int(object_ptr);
                case Keys.g_string:
                    return greycat.Pointer_stringify(greycat._gstring__get(object_ptr));
                default:
                    return null;
            }
        }
    }
}
export class Node extends GObject {
    set(name, value) {
        if (value === null) {
            greycat._gnode__set_null(this.native_ptr, GreyCat.prop_id_to_key(name, this));
        }
        else if (typeof value === 'string') {
            const js_str = value;
            const ptr_str = greycat._js_malloc(js_str.length + 1);
            greycat.writeAsciiToMemory(js_str, ptr_str, false);
            greycat._gnode__set_raw_string(this.native_ptr, GreyCat.prop_id_to_key(name, this), ptr_str);
            greycat._js_free(ptr_str);
        }
        else if (typeof value === 'number') {
            if (value % 1 !== 0) {
                greycat._gnode__set_double(this.native_ptr, GreyCat.prop_id_to_key(name, this), value);
            }
            else if (value > -9007199254740992 && value < 9007199254740992) {
                greycat._gnode__set_int(this.native_ptr, GreyCat.prop_id_to_key(name, this), value);
            }
            else {
                greycat._gnode__set_long(this.native_ptr, GreyCat.prop_id_to_key(name, this), value);
            }
        }
        else if (value instanceof GObject) {
            greycat._gnode__set(this.native_ptr, GreyCat.prop_id_to_key(name, this), value.ptr, greycat._object__type_key(value.ptr()));
        }
        else if (typeof value === 'boolean') {
        }
        else {
            const graph_ptr = greycat._node__graph(this.native_ptr);
            const anonymous_func_ptr = greycat._function__create(graph_ptr, this.native_ptr);
            GreyCat.elements[anonymous_func_ptr] = value;
            greycat._gnode__set(this.ptr, GreyCat.prop_id_to_key(name, this), anonymous_func_ptr, Keys.g_function);
            greycat._gobject__un_mark(anonymous_func_ptr, Keys.g_function);
        }
        return this;
    }
    get(name) {
        const pkey = GreyCat.prop_id_to_key(name);
        const ptype = greycat._node__type(this.native_ptr, pkey);
        const type = this.graph().type(ptype);
        if (type == null) {
            return null;
        }
        else {
            return type.box(greycat._node__get(this.native_ptr, pkey));
        }
    }
    getOrCreate(key, prop_type) {
        const pkey = GreyCat.prop_id_to_key(key, this);
        const ptype = GreyCat.prop_id_to_key(prop_type);
        const type = this.graph().type(ptype);
        if (type == null) {
            return null;
        }
        else {
            return type.box(greycat._gnode__get_or_create(this.native_ptr, pkey, ptype));
        }
    }
}
export class OpenNode extends Node {
    constructor(ptr) {
        super(ptr);
        return new Proxy(this, {
            get: (obj, prop) => {
                const p = prop.toString();
                return p in obj ? obj[p] : obj.get(p);
            },
            set: (obj, prop, value) => {
                const p = prop.toString();
                if (p in obj) {
                    obj[p] = value;
                }
                else {
                    obj.set(p, value);
                }
                return true;
            },
        });
    }
}
export class Context {
    constructor(ptr) {
        this.native_ptr = 0;
        this.native_ptr = ptr;
        return new Proxy(this, {
            get: (obj, prop) => {
                const p = prop.toString();
                return p in obj ? obj[p] : obj.get(p);
            },
            set: (obj, prop, value) => {
                const p = prop.toString();
                if (p in obj) {
                    obj[p] = value;
                }
                else {
                    obj.set(p, value);
                }
                return true;
            },
        });
    }
    set(key, value) {
        if (value == null) {
            greycat._gctx__set_null(this.native_ptr, GreyCat.prop_id_to_key(key, this));
        }
        else if (typeof value === 'string') {
            const js_str = value;
            const ptr_str = greycat._js_malloc(js_str.length + 1);
            greycat.writeAsciiToMemory(js_str, ptr_str, false);
            greycat._gctx__set_raw_string(this.native_ptr, GreyCat.prop_id_to_key(key, this), ptr_str);
            greycat._js_free(ptr_str);
        }
        else if (typeof value === 'number') {
            if (value % 1 !== 0) {
                greycat._gctx__set_double(this.native_ptr, GreyCat.prop_id_to_key(key, this), value);
            }
            else if (value > Number.MIN_SAFE_INTEGER - 1 && value < Number.MAX_SAFE_INTEGER + 1) {
                greycat._gctx__set_int(this.native_ptr, GreyCat.prop_id_to_key(key, this), value);
            }
        }
        else if (typeof value === 'boolean') {
            greycat._gctx__set_bool(this.native_ptr, GreyCat.prop_id_to_key(key, this), value);
        }
        else {
            greycat._gctx__set(this.native_ptr, GreyCat.prop_id_to_key(key, this), value.ptr());
        }
        return this;
    }
    get(key) {
        const propKey = GreyCat.prop_id_to_key(key);
        const type_key = greycat._ctx__type(this.native_ptr, propKey);
        const type = this.graph().type(type_key);
        if (type == null) {
            return null;
        }
        else {
            return type.box(greycat._ctx__get(this.native_ptr, propKey));
        }
    }
    getOrCreate(key, type) {
        return null;
    }
    execute(f, onEnd) {
        if (onEnd) {
            if (onEnd instanceof GFunction) {
                greycat._gctx__on_end(this.native_ptr, onEnd.ptr());
            }
            else {
                const final_func_ptr = greycat._function__create(greycat._gctx__graph(this.native_ptr));
                GreyCat.elements[final_func_ptr] = onEnd;
                greycat._gctx__on_end(this.native_ptr, final_func_ptr);
                greycat._gobject__un_mark(final_func_ptr, Keys.g_function);
            }
        }
        if (typeof f === 'number') {
            greycat._gctx__execute_key(this.native_ptr, f);
        }
        else if (typeof f === 'string') {
            greycat._gctx__execute_key(this.native_ptr, GreyCat.hash(f));
        }
        else {
            greycat._gctx__execute(this.native_ptr, f.ptr());
        }
    }
    prepare(f) {
        if (typeof f === 'number') {
            greycat._gctx__prepare_execute_key(this.native_ptr, f);
        }
        else if (typeof f === 'string') {
            greycat._gctx__prepare_execute_key(this.native_ptr, GreyCat.hash(f));
        }
        else {
            greycat._gctx__prepare(this.native_ptr, f.ptr());
        }
        return this;
    }
    executePrepared() {
        greycat._gctx__execute_prepared(this.native_ptr);
    }
    ordinal() {
        return greycat._gctx__ordinal(this.native_ptr);
    }
    declare(key, value) {
        if (!value) {
            greycat._gctx__declare_null(this.native_ptr, GreyCat.prop_id_to_key(key, this));
        }
        else if (typeof value === 'string') {
            const js_str = value;
            const ptr_str = greycat._js_malloc(js_str.length + 1);
            greycat.writeAsciiToMemory(js_str, ptr_str, false);
            greycat._gctx__declare_raw_string(this.native_ptr, GreyCat.prop_id_to_key(key, this), ptr_str);
            greycat._js_free(ptr_str);
        }
        else if (value % 1 !== 0) {
            greycat._gctx__declare_double(this.native_ptr, GreyCat.prop_id_to_key(key, this), value);
        }
        else if (value > Number.MIN_SAFE_INTEGER - 1 && value < Number.MAX_SAFE_INTEGER + 1) {
            greycat._gctx__declare_int(this.native_ptr, GreyCat.prop_id_to_key(key, this), value);
        }
        else {
            greycat._gctx__declare_long(this.native_ptr, GreyCat.prop_id_to_key(key, this), value);
        }
        return this;
    }
    bind(src, target) {
        greycat._gctx__bind(this.native_ptr, GreyCat.prop_id_to_key(src, this), GreyCat.prop_id_to_key(target, this));
        return this;
    }
    path() {
        const strPtr = greycat._gctx__path(this.native_ptr);
        const jsStr = greycat.Pointer_stringify(strPtr);
        greycat._js_free(strPtr);
        return jsStr;
    }
    toString() {
        const graph_ptr = greycat._gctx__graph(this.native_ptr);
        const buffer = greycat._ggraph__create_string(graph_ptr);
        greycat._gctx__json(this.native_ptr, buffer);
        greycat._gstring__close(buffer);
        const buffer_raw = greycat._gstring__get(buffer);
        const result = greycat.Pointer_stringify(buffer_raw);
        greycat._gobject__un_mark(buffer);
        return result;
    }
    toObject() {
        return JSON.parse(this.toString());
    }
    ptr() {
        return this.native_ptr;
    }
    graph() {
        const graph_ptr = greycat._gctx__graph(this.native_ptr);
        return GreyCat.elements[graph_ptr];
    }
}
export class ULongArray extends GObject {
    constructor(ptr) {
        super(ptr);
    }
    size() {
        return greycat._gulong_array__size(this.native_ptr);
    }
    set(offset, value) {
        greycat._gulong_array__set(this.native_ptr, offset, value);
        return this;
    }
    add(value) {
        greycat._gulong_array__add(this.native_ptr, value);
        return this;
    }
    get(offset) {
        return greycat._gulong_array__get(this.native_ptr, offset);
    }
}
export class LongArray extends GObject {
    constructor(ptr) {
        super(ptr);
    }
    size() {
        return greycat._glong_array__size(this.native_ptr);
    }
    set(offset, value) {
        greycat._glong_array__set(this.native_ptr, offset, value);
        return this;
    }
    add(value) {
        greycat._glong_array__add(this.native_ptr, value);
        return this;
    }
    get(offset) {
        return greycat._glong_array__get(this.native_ptr, offset);
    }
}
export class IntArray extends GObject {
    constructor(ptr) {
        super(ptr);
    }
    size() {
        return greycat._gint_array__size(this.native_ptr);
    }
    set(offset, value) {
        greycat._gint_array__set(this.native_ptr, offset, value);
        return this;
    }
    add(value) {
        greycat._gint_array__add(this.native_ptr, value);
        return this;
    }
    get(offset) {
        return greycat._gint_array__get(this.native_ptr, offset);
    }
}
export class DoubleArray extends GObject {
    constructor(ptr) {
        super(ptr);
    }
    size() {
        return greycat._gdouble_array__size(this.native_ptr);
    }
    set(offset, value) {
        greycat._gdouble_array__set(this.native_ptr, offset, value);
        return this;
    }
    add(value) {
        greycat._gdouble_array__add(this.native_ptr, value);
        return this;
    }
    get(offset) {
        return greycat._gdouble_array__get(this.native_ptr, offset);
    }
}
export class Matrix extends GObject {
    constructor(ptr) {
        super(ptr);
    }
    init(rows, columns) {
        greycat._gmatrix__init(this.native_ptr, rows, columns);
        return this;
    }
    set(row, column, value) {
        greycat._gmatrix__set(this.native_ptr, row, column, value);
        return this;
    }
    get(row, column) {
        return greycat._gmatrix__get(this.native_ptr, row, column);
    }
}
export class GArray extends GObject {
    constructor(ptr) {
        super(ptr);
    }
    size() {
        return greycat._garray__size(this.native_ptr);
    }
    set(offset, value) {
        if (value == null) {
            greycat._array__set_null(this.native_ptr, offset);
        }
        else if (typeof value === 'string') {
            const js_str = value;
            const ptr_str = greycat._js_malloc(js_str.length + 1);
            greycat.writeAsciiToMemory(js_str, ptr_str, false);
            greycat._array__set_raw_string(this.native_ptr, offset, ptr_str);
            greycat._js_free(ptr_str);
        }
        else if (typeof value === 'number') {
            if (value % 1 !== 0) {
                greycat._array__set_double(this.native_ptr, offset, value);
            }
            else if (value > Number.MIN_SAFE_INTEGER - 1 && value < Number.MAX_SAFE_INTEGER + 1) {
                greycat._array__set_int(this.native_ptr, offset, value);
            }
        }
        else if (typeof value === 'boolean') {
            greycat._array__set_bool(this.native_ptr, offset, value);
        }
        else {
            greycat._garray__set(this.native_ptr, offset, value.ptr());
        }
        return this;
    }
    add(value) {
        if (value == null) {
            greycat._array__add_null(this.native_ptr);
        }
        else if (typeof value === 'string') {
            const js_str = value;
            const ptr_str = greycat._js_malloc(js_str.length + 1);
            greycat.writeAsciiToMemory(js_str, ptr_str, false);
            greycat._array__add_raw_string(this.native_ptr, ptr_str);
            greycat._js_free(ptr_str);
        }
        else if (typeof value === 'number') {
            if (value % 1 !== 0) {
                greycat._array__add_double(this.native_ptr, value);
            }
            else if (value > Number.MIN_SAFE_INTEGER - 1 && value < Number.MAX_SAFE_INTEGER + 1) {
                greycat._array__add_int(this.native_ptr, value);
            }
        }
        else if (typeof value === 'boolean') {
            greycat._array__add_bool(this.native_ptr, value);
        }
        else {
            greycat._garray__add(this.native_ptr, value.ptr());
        }
        return this;
    }
    get(offset) {
        const type_key = greycat._array__get_type(this.native_ptr, offset);
        const type = this.graph().type(type_key);
        if (type == null) {
            return null;
        }
        else {
            return type.box(greycat._array__get(this.native_ptr, offset));
        }
    }
}
export class Binding {
    constructor(val) {
        this.val = val;
    }
}
export class Template {
    constructor(content) {
        this.content = content;
    }
}
export class GFunction extends GObject {
    constructor(ptr) {
        super(ptr);
    }
    setName(name) {
        greycat._gfunction__unsafe_set_key(this.native_ptr, GreyCat.prop_id_to_key(name, this));
        return this;
    }
    name() {
        const str_ptr = greycat._function__name(this.native_ptr);
        if (str_ptr === 0) {
            return '';
        }
        else {
            return greycat.Pointer_stringify(greycat._gstring__get(str_ptr));
        }
    }
    pipe(sub, params) {
        let params_ptr = 0;
        let params_size = 0;
        if (params != null) {
            const keys = Object.keys(params);
            params_size = keys.length;
            params_ptr = greycat._params__create(params_size);
            let i = 0;
            for (const key of keys) {
                const key_id = GreyCat.prop_id_to_key(key, this);
                const value = params[key];
                if (value == null) {
                    greycat._params__add_null(params_ptr, i, key_id);
                }
                else if (typeof value === 'string') {
                    const js_str = value;
                    const ptr_str = greycat._js_malloc(js_str.length + 1);
                    greycat.writeAsciiToMemory(js_str, ptr_str, false);
                    greycat._params__add_string(params_ptr, i, key_id, ptr_str, greycat._object__graph(this.native_ptr));
                    greycat._js_free(ptr_str);
                }
                else if (typeof value === 'number') {
                    if (value % 1 !== 0) {
                        greycat._params__add_double(params_ptr, i, params_size, key_id, value);
                    }
                    else if (value > Number.MIN_SAFE_INTEGER - 1 && value < Number.MAX_SAFE_INTEGER + 1) {
                        greycat._params__add_int(params_ptr, i, params_size, key_id, value);
                    }
                    else {
                        greycat._params__add_long(params_ptr, i, params_size, key_id, value);
                    }
                }
                else if (typeof value === 'boolean') {
                    greycat._params__add_bool(params_ptr, i, params_size, key_id, value);
                }
                else if (value instanceof Template) {
                    const js_str = value.content;
                    const ptr_str = greycat._js_malloc(js_str.length + 1);
                    greycat.writeAsciiToMemory(js_str, ptr_str, false);
                    greycat._params__add_template(params_ptr, i, key_id, ptr_str, greycat._object__graph(this.native_ptr));
                    greycat._js_free(ptr_str);
                }
                else if (value instanceof Binding) {
                    greycat._params__add_binding(params_ptr, i, params_size, key_id, value);
                }
                else if (value instanceof GObject) {
                    greycat._params__add_object(params_ptr, i, key_id, value.ptr());
                }
                else {
                    GreyCat.Logger.error('unknown param type ', key);
                    greycat._params__add_null(params_ptr, i, key_id);
                }
                i++;
            }
        }
        if (typeof sub === 'string' || typeof sub === 'number') {
            const sub_key = GreyCat.prop_id_to_key(sub, this);
            if (params_size !== 0) {
                greycat._gfunction__pipe_key_with(this.native_ptr, sub_key, params_size, params_ptr);
            }
            else {
                greycat._gfunction__pipe_key(this.native_ptr, sub_key);
            }
        }
        else if (sub instanceof GFunction) {
            if (params_size !== 0) {
                greycat._gfunction__pipe_with(this.native_ptr, sub.ptr(), params_size, params_ptr);
            }
            else {
                greycat._gfunction__pipe(this.native_ptr, sub.ptr);
            }
        }
        else {
            const sub_ptr = greycat._function__create(greycat._gctx__graph(this.native_ptr), this.native_ptr);
            GreyCat.elements[sub_ptr] = sub;
            if (params_size !== 0) {
                greycat._gfunction__pipe_with(this.native_ptr, params_size, params_ptr);
            }
            else {
                greycat._gfunction__pipe(this.native_ptr, sub_ptr);
            }
            greycat._gobject__un_mark(sub_ptr, Keys.g_function);
        }
        greycat._params__destroy(params_ptr, params_size);
        return this;
    }
    parse(greycatl_data) {
        const ptr_str = greycat._js_malloc(greycatl_data.length + 1);
        greycat.writeAsciiToMemory(greycatl_data, ptr_str, false);
        const result = greycat._gfunction__parse(this.native_ptr, ptr_str);
        greycat._js_free(ptr_str);
        if (!result) {
            throw new Error('GreyCat parse error');
        }
        return this;
    }
}
export class Plugin {
    start(graph) {
    }
    stop(graph) {
    }
}
export class Graph {
    constructor(cacheSize, bufferSize) {
        this.native_ptr = 0;
        if (cacheSize === undefined) {
            cacheSize = 1000;
        }
        if (bufferSize === undefined) {
            bufferSize = 10;
        }
        this.native_ptr = greycat._graph__create(cacheSize, bufferSize);
        GreyCat.elements[this.native_ptr] = this;
        this.type(Keys.g_array).setClass(GArray);
        this.type(Keys.g_long_array).setClass(LongArray);
        this.type(Keys.g_ulong_array).setClass(ULongArray);
        this.type(Keys.g_int_array).setClass(IntArray);
        this.type(Keys.g_matrix).setClass(Matrix);
        this.type(Keys.g_function).setClass(GFunction);
    }
    type(id) {
        const type_ptr = greycat._ggraph__type(this.native_ptr, GreyCat.prop_id_to_key(id, this));
        if (type_ptr === 0) {
            return null;
        }
        else {
            let type_obj = GreyCat.elements[type_ptr];
            if (type_obj == null) {
                type_obj = new Type(type_ptr);
                GreyCat.elements[type_ptr] = type_obj;
            }
            return type_obj;
        }
    }
    newObject(type_id) {
        const gc_type = this.type(type_id);
        if (gc_type == null) {
            return null;
        }
        else if (gc_type.isPrimitive()) {
            return null;
        }
        else {
            return gc_type.box(greycat._ggraph__create_object_using(gc_type.ptr()));
        }
    }
    newContext() {
        const ptr = greycat._ctx__create(this.native_ptr);
        const new_ctx = new Context(ptr);
        GreyCat.elements[ptr] = new_ctx;
        return new_ctx;
    }
    newFunction() {
        return new GFunction(greycat._ggraph__create_function(this.native_ptr));
    }
    newType() {
        const new_type_ptr = greycat._ggraph__create_fixed_node_type(this.native_ptr);
        const new_type = new Type(new_type_ptr);
        GreyCat.elements[new_type_ptr] = new_type;
        return new_type;
    }
    declareFunction(id, func) {
        if (func instanceof GFunction) {
            greycat._ggraph__declare_function(this.native_ptr, GreyCat.prop_id_to_key(id, this), func.ptr());
        }
        else {
            const ptr = greycat._function__create(this.native_ptr, 0);
            GreyCat.elements[ptr] = func;
            greycat._ggraph__declare_function(this.native_ptr, GreyCat.prop_id_to_key(id, this), ptr);
            greycat._gobject__un_mark(ptr, Keys.g_function);
        }
    }
    addPlugin(plugin) {
        const plug_ptr = greycat._plugin__create();
        GreyCat.elements[plug_ptr] = plugin;
        greycat._ggraph__add_plugin(this.native_ptr, plug_ptr);
        return this;
    }
    configurePlugin(plugin, params) {
        let params_ptr = 0;
        let params_size = 0;
        if (params != null) {
            const keys = Object.keys(params);
            params_size = keys.length;
            params_ptr = greycat._params__create(params_size);
            let i = 0;
            for (const key of keys) {
                const key_id = GreyCat.prop_id_to_key(key, this);
                const value = params[key];
                if (value == null) {
                    greycat._params__add_null(params_ptr, i, key_id);
                }
                else if (typeof value === 'string') {
                    const ptr_str = greycat._js_malloc(value.length + 1);
                    greycat.writeAsciiToMemory(value, ptr_str, false);
                    greycat._params__add_string(params_ptr, i, key_id, ptr_str, this.native_ptr);
                    greycat._js_free(ptr_str);
                }
                else if (typeof value === 'number') {
                    if (value % 1 !== 0) {
                        greycat._params__add_double(params_ptr, i, params_size, key_id, value);
                    }
                    else if (value > Number.MIN_SAFE_INTEGER - 1 && value < Number.MAX_SAFE_INTEGER + 1) {
                        greycat._params__add_int(params_ptr, i, params_size, key_id, value);
                    }
                    else {
                        greycat._params__add_long(params_ptr, i, params_size, key_id, value);
                    }
                }
                else if (typeof value === 'boolean') {
                    greycat._params__add_bool(params_ptr, i, params_size, key_id, value);
                }
                else if (value instanceof Template) {
                    const js_str = value.content;
                    const ptr_str = greycat._js_malloc(js_str.length + 1);
                    greycat.writeAsciiToMemory(js_str, ptr_str, false);
                    greycat._params__add_template(params_ptr, i, key_id, ptr_str, greycat._object__graph(this.native_ptr));
                    greycat._js_free(ptr_str);
                }
                else if (value instanceof Binding) {
                    greycat._params__add_binding(params_ptr, i, params_size, key_id, value);
                }
                else if (value instanceof GObject) {
                    greycat._params__add_object(params_ptr, i, key_id, value.ptr());
                }
                else {
                    GreyCat.Logger.error('unknown param type ', key);
                    greycat._params__add_null(params_ptr, i, key_id);
                }
                i++;
            }
        }
        greycat._ggraph__configure_plugin(this.native_ptr, GreyCat.prop_id_to_key(plugin), params_size, params_ptr);
        return this;
    }
    exportKey(id) {
        const gstring_ptr = greycat._ggraph__meta(this.native_ptr, GreyCat.prop_id_to_key(id, this));
        if (gstring_ptr === 0) {
            return null;
        }
        return greycat.Pointer_stringify(gstring_ptr);
    }
    exportTypes() {
        const buffer = greycat._ggraph__create_string(this.native_ptr);
        greycat._ggraph_export_types(this.native_ptr, buffer);
        greycat._gstring__close(buffer);
        const buffer_raw = greycat._gstring__get(buffer);
        const result = greycat.Pointer_stringify(buffer_raw);
        greycat._gobject__un_mark(buffer, Keys.g_string);
        return result;
    }
    exportFunctions() {
        const buffer = greycat._ggraph__create_string(this.native_ptr);
        greycat._ggraph_export_functions(this.native_ptr, buffer);
        greycat._gstring__close(buffer);
        const buffer_raw = greycat._gstring__get(buffer);
        const result = greycat.Pointer_stringify(buffer_raw);
        greycat._gobject__un_mark(buffer, Keys.g_string);
        return result;
    }
    destroy() {
        if (this.native_ptr !== 0) {
            delete GreyCat.elements[this.native_ptr];
            greycat._ggraph__destroy(this.native_ptr);
            this.native_ptr = 0;
        }
    }
    heapSize() {
        return greycat._graph__size_heap(this.native_ptr);
    }
    cacheSize() {
        return greycat._graph__size_cache(this.native_ptr);
    }
    bufferSize() {
        return greycat._graph__size_buffer(this.native_ptr);
    }
    enableDebug() {
        greycat._ggraph__enable_debug(this.native_ptr);
    }
    disableDebug() {
        greycat._ggraph__disable_debug(this.native_ptr);
    }
    detach() {
    }
    attach() {
    }
    parse(script) {
        const ptr_str = greycat._js_malloc(script.length + 1);
        greycat.writeAsciiToMemory(script, ptr_str, false);
        const func_ptr = greycat._ggraph__parse(this.native_ptr, ptr_str);
        greycat._js_free(ptr_str);
        if (func_ptr === 0) {
            return null;
        }
        else {
            return new GFunction(func_ptr);
        }
    }
    execute(script, onEnd) {
        this.newContext().execute(this.parse(script) || Keys.g_noop, onEnd);
    }
    logError(msg) {
        const ptr_str = greycat._js_malloc(msg.length + 1);
        greycat.writeAsciiToMemory(msg, ptr_str, false);
        greycat._graph__log_error(this.native_ptr, ptr_str, msg.length);
        greycat._js_free(ptr_str);
    }
    logWarning(msg) {
        const ptr_str = greycat._js_malloc(msg.length + 1);
        greycat.writeAsciiToMemory(msg, ptr_str, false);
        greycat._graph__log_warning(this.native_ptr, ptr_str, msg.length);
        greycat._js_free(ptr_str);
    }
    logInfo(msg) {
        const ptr_str = greycat._js_malloc(msg.length + 1);
        greycat.writeAsciiToMemory(msg, ptr_str, false);
        greycat._graph__log_info(this.native_ptr, ptr_str, msg.length);
        greycat._js_free(ptr_str);
    }
}
export class WebSocketAdapter {
    constructor(s) {
        this.buffer = [];
        this.socket = s;
    }
}
export class GreyCat {
    static onReady(callback) {
        const promise = new Promise((resolve) => {
            if (this.isInitiliazed) {
                resolve();
            }
            else {
                greycat.onRuntimeInitialized = () => {
                    this.isInitiliazed = true;
                    resolve();
                };
            }
        });
        if (callback) {
            return promise.then(callback);
        }
        else {
            return promise;
        }
    }
    static newGraph(cacheSize, bufferSize) {
        return new Graph(cacheSize, bufferSize);
    }
    static newWebSocketClient(nptr, url_ptr, port, use_wss) {
        const address = greycat.Pointer_stringify(url_ptr);
        const url = (use_wss === 1 ? 'wss://' : 'ws://') + address + ':' + port;
        let socket;
        try {
            socket = new WebSocket(url, 'default', { rejectUnauthorized: false });
        }
        catch (err) {
            GreyCat.Logger.error(err);
        }
        if (socket) {
            socket.binaryType = 'arraybuffer';
            const ws = new WebSocketAdapter(socket);
            socket.onopen = () => {
                for (let i = 0; i < ws.buffer.length; i++) {
                    socket.send(ws.buffer[i].buffer);
                }
                ws.buffer = [];
            };
            socket.onerror = () => {
                GreyCat.Logger.error(new Error(`An error occured with WebSocket('${url}')`));
            };
            socket.onmessage = (e) => {
                const msgBuf = new Uint8Array(e.data);
                const bug_len = msgBuf.length;
                const buf = greycat._js_malloc(bug_len);
                greycat.HEAPU8.set(msgBuf, buf);
                greycat._gwebsocket_client__on_msg(nptr, buf, bug_len);
                greycat._js_free(buf);
            };
            GreyCat.elements[nptr] = ws;
        }
    }
    static webSocketClientSend(client_id, data_ptr, len) {
        const ws = GreyCat.elements[client_id];
        const new_buffer = new Uint8Array(greycat.buffer).slice(data_ptr, data_ptr + len);
        if (ws.socket.readyState !== ws.socket.OPEN) {
            ws.buffer.push(new Uint8Array(new_buffer));
        }
        else {
            ws.socket.send(new_buffer.buffer);
        }
    }
    static hash(str) {
        let hash = 0;
        let char;
        if (str.length === 0) {
            return hash;
        }
        for (let i = 0; i < str.length; i++) {
            char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash;
        }
        return hash;
    }
    static destroyWebSocketClient(nptr) {
        const ws = GreyCat.elements[nptr];
        if (ws.socket.readyState === ws.socket.OPEN) {
            ws.socket.close();
        }
        delete GreyCat.elements[nptr];
    }
    static prop_id_to_key(param, origin) {
        if (typeof param === 'string') {
            const paramHash = GreyCat.hash(param);
            if (origin !== undefined) {
                let graph_ptr;
                if (origin instanceof Graph) {
                    graph_ptr = origin.native_ptr;
                }
                else if (origin instanceof Context) {
                    graph_ptr = greycat._gctx__graph(origin.ptr());
                }
                else if (origin instanceof GObject) {
                    graph_ptr = greycat._object__graph(origin.ptr());
                }
                if (greycat._ggraph__is_meta(graph_ptr, paramHash) === 0) {
                    const meta = param;
                    const buffer = greycat._js_malloc(meta.length + 1);
                    greycat.writeAsciiToMemory(meta, buffer, false);
                    greycat._ggraph__declare_meta(graph_ptr, paramHash, buffer);
                    greycat._js_free(buffer);
                }
            }
            return paramHash;
        }
        else {
            return param;
        }
    }
}
GreyCat._module = greycat;
GreyCat.elements = new Proxy({}, {
    get: (target, prop) => {
        return target[prop];
    },
    set: (target, prop, value) => {
        target[prop] = value;
        return true;
    },
});
GreyCat.isInitiliazed = false;
GreyCat.Logger = console;
global.GreyCat = GreyCat;
//# sourceMappingURL=greycat.js.map